<template>
  <div
    class="d-flex ga-2 pay-range-header"
    :class="hoverEnabled ? 'hover-enabled' : ''"
    @click="$emit('click', $event)"
  >
    <CountryFlag :flag-url="countryFlag" :country-code="countryCode" :size="18" />
    <span class="pay-range-name"
      >{{ payRangeName }} > {{ payRangeLocation }}</span
    >
    <span class="pay-range-expressed"
      >({{ payRangeCurrencyCode }}/{{ payRangeExpressed }})</span
    >
  </div>
</template>
<script setup>
import { defineProps, computed } from "vue";
import CountryFlag from "@components/CountryFlag/CountryFlag.vue";
import { alpha2FromAlpha3 } from "@components/utils/countryFlagIcon";

const props = defineProps({
  countryFlag: {
    type: String,
    required: true,
  },
  payRangeName: {
    type: String,
    required: true,
  },
  payRangeLocation: {
    type: String,
    required: true,
  },
  payRangeExpressedAs: {
    type: String,
    required: true,
  },
  payRangeCurrencyCode: {
    type: String,
    required: true,
  },
  hoverEnabled: {
    type: Boolean,
    required: false,
    default: true
  },
});

const payRangeExpressed = computed(() => {
  return props.payRangeExpressedAs?.replace("per_", "").toUpperCase() || "Hour";
});

/**
 * Derive the ISO alpha-2 country code from the flag URL so CountryFlag can set a
 * meaningful alt and its flagcdn fallback. Handles flagcdn.com/{code}... URLs and
 * self-hosted /static/images/flags/{alpha3}.svg paths; returns "" when unknown.
 */
const countryCode = computed(() => {
  const raw = String(props.countryFlag || "").trim();
  if (!raw) return "";
  const cdn = raw.match(/flagcdn\.com\/(?:w\d+\/)?([a-z]{2})(?:\.|\/|$)/i);
  if (cdn) return cdn[1].toLowerCase();
  const selfHosted = raw.match(/(?:^|\/)([a-z]{3})\.svg$/i);
  if (selfHosted) return alpha2FromAlpha3(selfHosted[1]);
  return "";
});
</script>
<style scoped>
.pay-range-header {
  display: flex;
  gap: 9px;
  align-items: center;
}
.hover-enabled:hover {
  border-radius: 10px;
  background: #f2edff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  cursor: url("../assets/cursorArrow.svg"), auto;
}
.hover-enabled {
  padding: 12px 10px !important;
}
.pay-range-header .pay-range-name {
  color: #101828;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  align-items: center;
}
.pay-range-header .pay-range-expressed {
  color: #101828;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-left: 2px;
}
</style>
